import { Menu } from "semantic-ui-react";
import React from "react";
import { NavLink, useRouteMatch } from "react-router-dom";
import { useSettingValue } from "../../utils/Hooks";

export const PositionDetailTabs = () => {
  let { url } = useRouteMatch();
  const isPositionTasksEnabled = useSettingValue("T013_POSITION_TASKS_ENABLED");
  return (
    <Menu secondary pointing>
      <Menu.Item as={NavLink} to={`${url}/funcionarios`}>
        Funcionários
      </Menu.Item>
      <Menu.Item as={NavLink} to={`${url}/historico`}>
        Histórico
      </Menu.Item>
      {isPositionTasksEnabled && (
        <Menu.Item as={NavLink} to={`${url}/tarefas`}>
          Tarefas da Função
        </Menu.Item>
      )}
    </Menu>
  );
};
